import _classPrivateFieldInitSpec from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/esnext.iterator.map.js";
import JsonMappedModel from "@/assets/js/models/helpers/JsonMappedModel";
import TutorialCollection from "@/assets/js/models/tutorial/TutorialCollection";
var _attributes = /*#__PURE__*/new WeakMap();
export default class TutorialCategory extends JsonMappedModel {
  constructor(data) {
    super(data);
    _classPrivateFieldInitSpec(this, _attributes, {
      [TutorialCategory.id_attribute_name]: null,
      [TutorialCategory.category_name_attribute_name]: null,
      [TutorialCategory.category_state_attribute_name]: null,
      [TutorialCategory.category_tutorials_attribute_name]: TutorialCollection
    });
    _defineProperty(this, "publishLoading", {
      content: false
    });
    _defineProperty(this, "loading", {
      content: false
    });
    this.map(data, _classPrivateFieldGet(_attributes, this));
  }
  static getNameAttributeName() {
    return this.category_name_attribute_name;
  }
  isLoading() {
    return this.loading.content;
  }
  startLoading() {
    this.loading.content = true;
    return this;
  }
  endLoading() {
    this.loading.content = false;
    return this;
  }
  startPublishLoading() {
    this.publishLoading.content = true;
    return this;
  }
  endPublishLoading() {
    this.publishLoading.content = false;
    return this;
  }
  isPublishLoading() {
    return this.publishLoading.content;
  }
  getTutorials() {
    return this.getAttribute(TutorialCategory.category_tutorials_attribute_name);
  }
  getName() {
    return this.getAttribute(TutorialCategory.category_name_attribute_name);
  }
  isPublished() {
    return this.getAttribute(TutorialCategory.category_state_attribute_name);
  }
}
_defineProperty(TutorialCategory, "id_attribute_name", 'category_id');
_defineProperty(TutorialCategory, "category_name_attribute_name", 'category_name');
_defineProperty(TutorialCategory, "category_state_attribute_name", 'category_state');
_defineProperty(TutorialCategory, "category_tutorials_attribute_name", 'category_tutorials');